export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            OTAN Mektep
          </a>{' '}
        </div>

        <div className='collapse navbar-collapse navbar-expand-sm' id='bs-example-navbar-collapse-1'>
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#testimonials' className='page-scroll'>
                Решения
              </a>
          </li>
            <li>
              <a href='#about' className='page-scroll'>
                Описание
              </a>
            </li>
            <li>
              <a href='#features' className='page-scroll'>
                Возможности
              </a>
            </li>
            <li>
              <a href='#services' className='page-scroll'>
                Услуги
              </a>
            </li>
            <li>
              <a href='#patents' className='page-scroll'>
                Патенты
              </a>
            </li>
            <li>
              <a href="doc.html" type="application/pdf" target="_blank" rel='noopener noreferrer'>
                Документация
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                Контакты
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

